<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import { useGameStore } from '@/stores/gameStore.ts'
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import GenericIconWithColoredNumber from '@/components/Elements/Images/Icons/GenericIconWithColoredNumber.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="gameStore.player!.profileImage"
    :toast-text="t('news.types.creditPenalty.title')"
  >
      <NewsItemBaseStructure
        :newsItem="props.newsItem"
        :item-image="gameStore.player!.profileImage"
        :header="t('news.types.creditPenalty.title')"
      >
        <p class="pb-2">{{ t('news.types.creditPenalty.body') }}</p>
        <div v-if="props.newsItem.contentData.action_taken.destroyRandomBuilding > 0">{{ t('news.types.creditPenalty.buildingsSold', { count: props.newsItem.contentData.action_taken.destroyRandomBuilding }) }}</div>
        <div v-if="props.newsItem.contentData.action_taken.destroyRandomShip > 0">{{ t('news.types.creditPenalty.shipsSold', { count: props.newsItem.contentData.action_taken.destroyRandomShip }) }}</div>
        <div v-if="props.newsItem.contentData.action_taken.dropPopulation > 0">{{ t('news.types.creditPenalty.populationDecrease', { count: props.newsItem.contentData.action_taken.dropPopulation }) }}</div>
        <div class="flex pt-2"><div class="pr-2">{{ t('news.types.creditPenalty.creditsRecovered') }}</div><GenericIconWithColoredNumber :amount="props.newsItem.contentData.credits_recovered" type="credit"/></div>

      </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>